import { render, staticRenderFns } from "./YesNoInput.vue?vue&type=template&id=e47f96c2&scoped=true&"
import script from "./YesNoInput.vue?vue&type=script&lang=js&"
export * from "./YesNoInput.vue?vue&type=script&lang=js&"
import style0 from "./YesNoInput.vue?vue&type=style&index=0&id=e47f96c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47f96c2",
  null
  
)

export default component.exports